import Vue from 'vue'
import moment from 'moment/moment'

Vue.mixin({
  methods: {
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        clickNotClose: true,
        title: 'Confirm',
        acceptText: 'Ok',
        text
      })
    },
    openNotify ({title, text, icon, color}) {
      this.$vs.notify({
        title,
        text,
        iconPack: 'feather',
        icon,
        color
      })
    },
    changeDateFormat (date) {
      return moment(date).format('ddd, MMM D, YYYY')
    },
    changeDateTimeFormat (dateTime) {
      return moment(dateTime).format('ddd, MMM D, YYYY, hh:mm A')
    },
    changeDateFormat1 (dateTime) {
      return moment(dateTime).format('DD/MM/YYYY')
    },
    changeTimeFormat1 (dateTime) {
      return moment(dateTime).format('hh:mm A')
    },
    linkChanger (link) {
      this.$vs.loading()
      this.$router.push(link).then(() => this.$vs.loading.close()).catch(() => this.$vs.loading.close())
    }
  }
})
